<template>
	<div>
		<v-row dense>
			<v-col cols="10" sm="10" md="10" lg="10" xl="10">
				<viewer-table :value="$options.loginProfile" :headers="$options.headers" :items="$options.items"></viewer-table>
			</v-col>
		</v-row>
	</div>
</template>

<script>
// globals
// locals

import i18n from './dictionary';
// models
// components
import ViewerTable from '@/components/base/viewer/viewerTable/ViewerTable.vue';
import { Login } from '@/plugins/clientModels';
// mixins

export default {
	name: `MyProfileViewerFields`,
	components: { ViewerTable },
	mixins: [],
	i18n,
	props: {
		value: {
			type: Object,
			required: true,
		},
	},
	created() {
		this.$options.headers = [
			{
				align: 'start',
			},
			{
				align: 'end',
			},
		];
		this.$options.items = [
			{
				value: 'general.name',
			},
			{
				value: 'general.username',
			},
			{
				value: 'general.email',
			},
			{
				value: 'references.worker.references.person',
				renderInput: {
					__label: this.$t('worker'),
					itemText: (item) =>
						this.$_.get(item, 'general.lastname', '') + ' ' + this.$_.get(item, 'general.firstname', ''),
				},
			},

			{
				value: 'status.passwordUpdatePending',
			},
			{
				value: 'status.blocked',
			},
			{
				value: 'references.groups',
			},
		];
		this.$options.loginProfile = new Login(this.value);
	},
};
</script>
